import { call, put, takeLatest } from 'typed-redux-saga/macro';
import moment from 'moment';
import { memberApi } from '../../lib/api';
import { TVitalHistoryType } from '../../types/vital-history';
import { actions } from '../ducks/vital-history';
import { vitalHistoryMeta, vitalTimelineURLs } from '../../helpers/vital-data-helpers';
import { getVitalTimeline, getVitalTimelineV2 } from '../../services/vital-data';

function* getChartData({ payload }: any) {
  const type: TVitalHistoryType = payload.type;
  const userId: string = payload.userId;

  const urlParts = vitalTimelineURLs[type];

  const params: any = {
    ...urlParts,
    userId,
    step: 'day',
    dateFrom: moment().subtract(1, 'years').format('YYYY-MM-DDTHH:mm:ss.SSS'),
  };
  let params2: any = null;
  if (type === 'SYSTOLIC') {
    params2 = {
      ...params,
      ...vitalTimelineURLs['DIASTOLIC'],
    };
  }
  try {
    let req2: any = null;
    let listReq2: any = null;

    const req: any = yield* call(memberApi.getVitalTimeline, params);
    const listReq: any = yield* call(memberApi.getVitalHistory, params);

    if (params2) {
      req2 = yield* call(memberApi.getVitalTimeline, params2);
      listReq2 = yield* call(memberApi.getVitalHistory, params2);
    }
    yield put(
      actions.getChartDataSuccess(req2 ? [req.data.data, req2.data.data] : [req.data.data]),
    );
    yield put(
      actions.getHistoryListSuccess(
        listReq2 ? [listReq.data.data, listReq2.data.data] : [listReq.data.data],
      ),
    );
  } catch {}
}

function* getHistoryMeta({ payload }: any) {
  const type: TVitalHistoryType = payload;
  yield put(
    actions.getHistoryMetaSuccess({
      type,
      ...vitalHistoryMeta[type],
    }),
  );
}

const V2_TYPES = ['WAIST', 'BMI'];

/**
 * Get timeline data
 * @param param0 G
 */
function* getTimelineRequest({ payload }: ReturnType<typeof actions.getTimelineRequest>) {
  try {
    if (payload.type === 'BLOOD_PRESSURE') {
      // @ts-ignore
      const sysRes = yield call(
        getVitalTimelineV2,
        payload.type,
        payload.step,
        payload.dateFrom,
        payload.dateTo,
        payload.userId,
        payload.providerId,
        'systolic_pressure',
      );
      // @ts-ignore
      const diaRes = yield call(
        getVitalTimelineV2,
        payload.type,
        payload.step,
        payload.dateFrom,
        payload.dateTo,
        payload.userId,
        payload.providerId,
        'diastolic_pressure',
      );
      yield put(
        actions.getTimelineSuccess({
          // @ts-ignore
          BLOOD_PRESSURE: {
            systolic: {
              ...sysRes.data.data,
              values: sysRes.data.data.values || [],
            },
            diastolic: {
              ...diaRes.data.data,
              values: diaRes.data.data.values || [],
            },
          },
        }),
      );
    } else {
      // @ts-ignore
      const response: any = yield call(
        getVitalTimelineV2,
        payload.type,
        payload.step,
        payload.dateFrom,
        payload.dateTo,
        payload.userId,
        payload.providerId,
      );

      yield put(
        actions.getTimelineSuccess({
          [payload.type]: {
            ...response.data.data,
            values: response.data.data.values || [],
          },
        }),
      );
    }
  } catch (error) {
    yield put(actions.getTimelineError());
    console.error(`getTimelineRequest err:`, error);
  }
}

function* vitalHistory() {
  yield takeLatest(actions.getChartDataRequest, getChartData);
  yield takeLatest(actions.getHistoryMetaRequest, getHistoryMeta);

  yield takeLatest(actions.getTimelineRequest, getTimelineRequest);
}

export default vitalHistory;
